export const trainingTypeData = [
  {
    Type: "Git Training",
    Description: "Git training covers managing code changes and collaboration using Git commands and workflows",
    Status: "Active",
    key: "1",
  },
  {
    Type: "HTML Training",
    Description: "HTML training teaches how to create and structure web pages using HTML tags and elements.",
    Status: "Active",
    key: "2",
  },
  {
    Type: "React Training",
    Description: "React training covers building UIs with components, state, and hooks.",
    Status: "Active",
    key: "3",
  },
  {
    Type: "Nodejs Training",
    Description: "Node.js training focuses on building server-side applications using JavaScript.",
    Status: "Active",
    key: "4",
  },
  {
    Type: "Vuejs Training",
    Description: "Vue.js training focuses on building UIs with Vue.js components.",
    Status: "Active",
    key: "5",
  },
];
